module.exports = __webpack_public_path__ + "c8be3d71e3722b899d1db5770b1a3cef.MP3";